import { render, staticRenderFns } from "./fieldsvacancy.vue?vue&type=template&id=a2d81710&lang=pug"
import script from "./fieldsvacancy.vue?vue&type=script&lang=js"
export * from "./fieldsvacancy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports